import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import useIsMobile from "../hooks/useIsMobile";
import MobileFooter from "../components/MobileFooter";
import MobileHeader from "../components/MobileHeader";
import "../css/Delivery.scss";

function Delivery() {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? <MobileHeader /> : <Header />}
      <Breadcrumbs />
      <h2 className="page-heading">Доставка и разгрузка</h2>
      <section className="delivery-content">
        <h2>
          Мы заботимся о том, чтобы ваш заказ прибыл точно в срок и в полной
          сохранности
        </h2>
        <p>
          Наша служба доставки работает по будням — с понедельника по пятницу, с
          9:00 до 18:00.
          <br />
          Мы ценим ваше время и всегда стремимся организовать доставку
          максимально <br /> удобно для вас.
        </p>

        <h3>УСЛОВИЯ И СТОИМОСТЬ ДОСТАВКИ</h3>
        <p>
          Стоимость доставки рассчитывается индивидуально и зависит от веса и
          объема <br /> заказа.
          <br />
          Мы предлагаем гибкую систему расчёта, чтобы вы могли заранее понимать{" "}
          <br />
          примерную стоимость услуги:
        </p>
        <ul>
          <li>- До 500 кг — базовая тарифная сетка</li>
          <li>- От 500 до 1000 кг — расширенный тариф</li>
          <li>- От 1000 до 5000 кг — индивидуальный расчет</li>
          <li>- От 5000 до 10000 кг — доставка крупными партиями</li>
          <li>- От 10000 до 20000 кг — спецтранспорт и согласование сроков</li>
        </ul>
        <p style={{ fontStyle: "italic" }}>
          Важно: стоимость может корректироваться в зависимости от габаритов и{" "}
          <br />
          удалённости от склада.
        </p>
        <p>
          Мы осуществляем доставку по Москве и Московской области, в пределах
          100 км от МКАД.
        </p>

        <h3>УСЛУГА ПОДЪЕМА ЗАКАЗА НА ЭТАЖ</h3>
        <p>
          Для вашего удобства мы предлагаем услугу подъема товаров на этаж.
          <br />
          Подъем осуществляется как с помощью лифта, так и вручную (до 5-го
          этажа <br /> включительно).
        </p>
        <p>
          <em style={{ fontStyle: "italic" }}>
            Условия зависят от веса заказа и наличия лифта
          </em>
        </p>

        <h3>МЕЛКОГАБАРИТНЫЕ ЗАКАЗЫ — ДО 30 КГ</h3>
        <p>Подъем осуществляется курьером:</p>
        <ul>
          <li>- До 20 кг — подъем до квартиры бесплатно;</li>
          <li>
            - От 20 до 30 кг:
            <ul>
              <li>- при наличии лифта — 150 руб.;</li>
              <li>- без лифта — 300 руб.</li>
            </ul>
          </li>
        </ul>

        <h3>КРУПНОГАБАРИТНЫЕ ЗАКАЗЫ — ОТ 30 ДО 1000 КГ</h3>
        <p>Подъем осуществляется грузчиками:</p>
        <ul>
          <li>- Услуга доступна только в пределах МКАД;</li>
          <li>- Время работы грузчиков — с 10:00 до 18:00 по будням;</li>
          <li>
            - Заказ на подъем оформляется до 15:00 дня, предшествующего
            доставке;
          </li>
          <li>
            - Вес каждого поднимаемого на этаж товара не должен превышать 35 кг;
            общий вес заказа — не более 1000 кг.
          </li>
        </ul>

        <h3>ЗАКАЗЫ СВЫШЕ 1000 КГ</h3>
        <p>
          Если вес заказа превышает 1000 кг, условия и стоимость подъема <br />
          согласовываются индивидуально с менеджером.
          <br />
          Мы подберем оптимальное решение в зависимости от условий вашего
          объекта и <br /> логистики.
        </p>
        <p>
          Если у вас остались вопросы или вы хотите уточнить стоимость доставки
          и <br /> подъема — просто свяжитесь с нами, и мы всё подробно
          расскажем.
        </p>
      </section>
      {isMobile ? <MobileFooter /> : <Footer />}
    </>
  );
}

export default Delivery;
